import { popover_slick_image_gallery } from './wc_block_scripts';

let viewed = false; // tillhör: animate_number_when_scrolling
let use_max_width_for_embed_video = false;
let max_width = 1344;
let count_slick_Slider = 0;

//Funktion som sätter maxhöjd efter vald bild i dubbelbildblocket
export function max_height_double_image_block() {
  $('.double-image-block-container').css('height', 'auto');
  if ($('.double-image-block-container').length == 0 || window.innerWidth < 768) return;

  $('.double-image-block-container').each(function() {
    var height = $('.max-height img', this).outerHeight();
    if (height < 1) {
      setTimeout(function(){
        max_height_double_image_block();
      }, 250);
    }
    $(this).css('height', height);
  });
}

//funktion som sätter höjd på bild i image/textblocket efter texten om "TAR SIN HÖJD" är valt
export function image_text_fill_height() {
  if ($('.fill-height').length == 0) return;

  $('.fill-height').each(function() {
    const parent = $(this).parent();
    const height = $('.image-text-content', parent).outerHeight();
    $('img', this).css('height', height);
  });

  $('.cover').each(function() {
    const coverparent = $(this).parent();
    const coverheight = $('.image-text-content', coverparent).outerHeight();
    $('img', this).css('height', coverheight);
  });
}



// 2 funktioner som tillsammans animerar siffror när man scollar in dem i window-view
function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

export function animate_number_when_scrolling() {
  if($(".block-achievements").length) {
    if (isScrolledIntoView($(".block-achievements")) && !viewed) {
        viewed = true;
        $('.counting').each(function () {
          if(!isNaN($(this).text())) {
            $(this).prop('Counter',0).animate({
                Counter: $(this).text()
            }, {
                duration: 2000,
                easing: 'swing',
                step: function (now) {
                    $(this).text(Math.ceil(now));
                }
            });
          }
      });
    }
  }
}

export function imagebank_block_functionality() {
  $('.fakeselect-dropdown').click(function() {
    $(this).toggleClass('active');
  });

  $('.imagebank-images-wrapper').each(function() {
    const parent = this;
    $('.information-btn', this).click(function() {
      const parent = $(this).closest('.imagebank-information');
      $('.imagebank-image-description', parent).toggleClass('active');
    });

    $('li', this).click(function(e) {
      if ($('.fakeselect-dropdown', parent).hasClass('active')) {
        e.stopPropagation();
      }
    });
  });
}

export function embed_video() {
  if ($('iframe').length) {
    let allVideos = $('iframe');
    let fluidEl = $('body');
    allVideos.each(function() {
      if($(this).parent().hasClass('fullwidth-iframe')) {
        $(this)
          .data('aspectRatio', this.height / this.width)
          .removeAttr('height')
          .removeAttr('width');
      } else {
        $(this)
          .data('aspectRatio', this.height / this.width);
      }
  });
  $(window).resize(function() {
    let newWidth = fluidEl.width();
      allVideos.each(function() {
        let el = $(this);
        if($(this).parent().hasClass('fullwidth-iframe')) {
          if(use_max_width_for_embed_video) {
            if(newWidth >= max_width) {
              newWidth = max_width;
            }
          }
          el.width(newWidth).height(newWidth * el.data('aspectRatio'));
        } else if(!$(this).parent().hasClass('fullwidth-iframe')) {
          if(el.attr('width') > fluidEl.width()) {
            el.width(newWidth).height(newWidth * el.data('aspectRatio'));
          }
        }
      });
    }).resize();
  }
}


// export function check_if_block_images_are_set() {
//   if($('.wp-block-columns .image-block').length) {
//     let check_height_numbers = [];
//     $('.wp-block-column .image-block .image-wrapper-img').each(function() {
//       check_height_numbers.push($(this).height());
//     });
//     if(check_height_numbers.includes(0)) {
//       check_if_block_images_are_set();
//     } else {
//       block_column_images();
//     }
//   }
// }

export function block_column_images() {
  if($('.wp-block-columns .image-block').length) {
    $('.wp-block-columns').each(function() {
      let images = $('.wp-block-column .adjust-image', this).length;
      if (1 < images) {
        let custom_height_set = false;
        let height = [];
        let value;
        $('.wp-block-column .adjust-image', this).each(function() {
          if($(this).height() > 0)  {
            height.push($(this).height());
          }
        });
        value = Math.min(...height);
        $('.wp-block-column .adjust-image .image-wrapper-img', this).each(function() {
          if($(this).height() == value && !custom_height_set) {
            $(this).addClass('custom-sets-height');
            custom_height_set = true;
          } else {
            $(this).height(value);
            $(this).addClass('custom-resized');
          }
        });
      }
    });

    $(window).resize(function() {
      $('.wp-block-columns').each(function() {
        if($('.custom-resized', this).length) {
          let height = $('.custom-sets-height', this).height();
          $('.wp-block-column .adjust-image .image-wrapper-img', this).each(function() {
            if(!$(this).hasClass('custom-sets-height')) {
              $(this).height(height);
            }
          });
        }
      });
    });
  }
}

export function block_column_fullwidth() {
  if($('.wp-block-columns').not('.container').length && $('.wp-block-columns').length) {
    $('.wp-block-columns').not('.container').each(function() {
      $(this).addClass('custom-background');
      let height = $(this).outerHeight();
      let color = $(this).css('background-color');
      let html = `
      <div class="custom-wp-blocks-columns">
        <div class="custom-wp-blocks-columns-background" style="height:${height}px; background-color: ${color}">
        </div>
      </div>
      `;
      $(this).before(html);
    });
    $(window).resize(function() {
      $('.custom-wp-blocks-columns').each(function() {
        let new_height = $(this).next().outerHeight();
        let color = $(this).next().css('background-color');
        $('.custom-wp-blocks-columns-background', this).css({'height' : `${new_height}px`, 'background-color': color});
      });
    });
  }
}

export function image_gallery() {
  if($('.image-gallery-wrapper').length) {
    $('.image-gallery-wrapper .image-gallery-filter li').click(function() {
      $('.image-gallery-wrapper .image-gallery-filter li').each(function() {
        $(this).removeClass('active');
      });
      $(this).addClass('active');
      let target = $('a', this).attr('href');
      let text = target.replace('#gallery-filter-','');
      if(text !== '#filter-title') {
        $(this).parent().siblings('.gallery-container').children('.image-gallery-post').each(function() {
        let data = $(this).attr('data-filter-tags');
        data = JSON.parse(data);
        data = data.includes(text);
        if(data) {
          $(this).attr('data-toggle', 'on');
        } else {
          $(this).attr('data-toggle', 'off');
          }
        });
      } else {
        $(this).parent().siblings('.gallery-container').children('.image-gallery-post').each(function(text) {
          $(this).attr('data-toggle', 'on');
        });
      }
    });
    if($('.image-gallery-wrapper .open-popover').length) {
      $('.image-gallery >.gallery-container .open-popover').click(function() {
        $(this).addClass('clicked-open');
        let slick_content = $('.image-gallery >.gallery-container').clone();
        $('#popover-slick .popover-slick-slider').prepend(slick_content);

        let image_to_open;
        $('#popover-slick .gallery-container .open-popover').each(function() {
          let show = $(this).attr('data-toggle');
          if(show == 'off') {
            $(this).detach();
          }
          if(show == 'on') {
            if($(this).hasClass('clicked-open')) {
              image_to_open = count_slick_Slider;
            }
            count_slick_Slider++;
          }
        });
        popover_slick_image_gallery(image_to_open);
        $('#popover-slick').addClass('active');
      });
      $('#popover-close-btn').click(function() {
        $('#popover-slick').removeClass('active');
        $('#popover-slick .popover-slick-slider').children().remove();
        count_slick_Slider = 0;
        $('.gallery-container .open-popover').each(function() {
          $(this).removeClass('clicked-open');
        });
      });
    }
  }
}
